import React, { useEffect, useState } from 'react'
import './home.less'
import { PageHeader } from './PageHeader'
import { FZSJ } from './FZSJ'
import { FX } from './FX'
import Radio from 'antd/lib/radio'
import { Button, Select, Table, Tabs, Tree } from 'antd'
import zoomImg from '../../assets/images/zoom.png'
import 资产总额 from '../../assets/images/资产总额.png'
import 资产总数 from '../../assets/images/资产总数.png'
import 报废资产数 from '../../assets/images/报废资产数.png'
import 闲置资产数 from '../../assets/images/闲置资产数.png'
import { FWL } from './FWL'
import { GLDWZJ } from './GLDWZJ'
import { ZTZB } from './ZTZB'
import useGlobalModel from '@/model/globalModel'
import { useHomerModal } from './homeModel'
import { DataNode, EventDataNode } from 'antd/lib/tree'
import { IDictDetail } from '../base/dict/dictService'
import FontIcon from '@/components/YhIcon'
import {
    CarryOutTwoTone,
    ControlTwoTone,
    DeleteTwoTone,
    FormOutlined,
    GoldTwoTone,
    InteractionTwoTone,
    MinusCircleFilled,
    PieChartTwoTone,
    SettingOutlined,
    SettingTwoTone,
} from '@ant-design/icons'
import useNavModel from '@/model/navModel'
import { ColumnsType } from 'antd/lib/table'
import { ISCMApplyListDetail } from '../apply/applyList/applyListTypes'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useDictModel } from '../base/dict/dictModel'
import { momentFormat } from '@/utils/utils'
import { ApplyModal } from './applyModal'
import { ISearchPage } from '@/types/AppTypes'
import { IAssetsListSearchFields, assetsListService } from '../manage/assetsList/assetsListService'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'

import { YhBox } from '@/components/YhBox'
import { NavigationModel } from './NavigationDrawer'
import { IconNameEnum, IconStatusEnum, IconUrlEnum } from '@/types/AppEnums'

export function Home() {
    const {
        user: { shopId, userName, userCode, shopCode },
        fetchUserList,
        setLoadingInfo,
        resetUser,
    } = useGlobalModel()
    const { selectedNavId, addNav, replaceNav } = useNavModel()
    const {
        loading,
        pgCfg,
        onClose,
        applyVisible,
        onApply,
        waitList,
        visitData,
        shareData,
        orgInsertData,
        groupInsertData,
        employeeValue,
        employeeData,
        groupInserList,
        setGroupInserList,
        loadOrgInsert,
        loadGroupInsert,
        zhupic,
        loadData,
        myCreatList,
        setMyCreatList,
        handleEmployee,
        type,
        setType,
        newOrgInsertData,
        setNewOrgInsertData,
        dataSource,
        setDataSource,
        optionsList,
        visible,
        setPage,
        setVisible,
        zichanzongshu,
        setZichanzongshu,
        zichanzonge,
        setZichanzonge,
        xianzhi,
        setXianzhi,
        baofei,
        setBaofei,
        checkValues,
        allnum,
        loadDataTable
    } = useHomerModal()
    const [selectedNodes, setSelectedNodes] = useState<any[]>([]) //树选中的行信息
    const changeUrl = async (value) => {
        addNav(IconUrlEnum[value])
    }
    const [zoomInfo, setZoomInfo] = useState<any>({
        fx: false,
        fwl: false,
        fzsj: false,
        gldwzj: false,
    })
    let aa = zichanzonge
    let bb = zichanzongshu
    let cc = baofei
    let dd = xianzhi
    console.log(aa)
    const { getSelectedDictOne } = useDictModel()
    useEffect(() => {
        setPage()
        allnum()
        loadDataTable()
    }, [])

    const columns: ColumnsType<ISCMApplyListDetail> = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '名称',
            width: 200,
            dataIndex: 'supplierName',
        },
        {
            title: '申请类型',
            width: 80,
            dataIndex: 'typeName',
        },
        {
            title: '申请人',
            width: 80,
            dataIndex: 'createUser',
        },
        {
            title: '申请时间',
            width: 100,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`,
        },
        {
            title: '申请状态',
            width: 80,
            dataIndex: 'status',
            render(status) {
                if (status === 'assets-apply-status.audit') {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: 'rgba(81, 223, 146,.2)',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: '#51DF92',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            待审批
                        </span>
                    )
                } else if (status === 'assets-apply-status.reject') {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: 'rgba(65, 101, 227,.1)',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: '#4165E3',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            已驳回
                        </span>
                    )
                } else if (status === 'assets-apply-status.pass') {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: 'rgba(247,61,61,.1)',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: 'rgba(255,0,0,1)',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            已通过
                        </span>
                    )
                }
            },
        },
        {
            title: '操作',
            width: 70,
            dataIndex: '',
            render: (text, record) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => onApply(record)}>
                    审批
                </span>
            ),
        },
    ]

    const myColumns: ColumnsType<ISCMApplyListDetail> = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '名称',
            width: 200,
            dataIndex: 'supplierName',
        },
        {
            title: '申请类型',
            width: 80,
            dataIndex: 'typeName',
        },
        {
            title: '申请时间',
            width: 140,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`,
        },
        {
            title: '申请状态',
            width: 80,
            dataIndex: 'status',
            render(status) {
                if (status === 'assets-apply-status.audit') {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: 'rgba(81, 223, 146,.2)',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: '#51DF92',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            待审批
                        </span>
                    )
                } else if (status === 'assets-apply-status.reject') {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: 'rgba(65, 101, 227,.1)',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: '#4165E3',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            已驳回
                        </span>
                    )
                } else if (status === 'assets-apply-status.pass') {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: 'rgba(247,61,61,.1)',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: 'rgba(255,0,0,1)',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            已通过
                        </span>
                    )
                }
            },
        },
        {
            title: '操作',
            width: 70,
            dataIndex: '',
            render: (text, record) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => onClose(record)}>
                    关闭
                </span>
            ),
        },
    ]

    useEffect(() => {
        loadData()
    }, [userName])

    const bottonTabnecolumns: ColumnsType<ISCMApplyListDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '物资名称',
            width: 160,
            fixed: 'left',
            dataIndex: 'materialName',
        },
        {
            title: '物资编码',
            width: 160,
            dataIndex: 'materialCode',
            fixed: 'left',
        },
        {
            title: '可用数量',
            width: 100,
            dataIndex: 'availableStock',
        },
        {
            title: '所属部门',
            width: 150,
            dataIndex: 'department',
        },
        {
            title: '当前存放地点',
            width: 120,
            dataIndex: 'deposit',
        },
        {
            title: '现使用人',
            width: 120,
            dataIndex: 'user',
        },
        {
            title: '资产状态',
            width: 100,
            dataIndex: 'status',
            render: (text: string) =>
                <>
                    <span style={{ color: text == 'assets-status.isUse' ? '#3ae388' : text == 'assets-status.leaveUnused' ? '#f3b800' : '#ff6b35', marginRight: '3px' }}>●</span>
                    {getSelectedDictOne(DictCodeEnmu.ASSETS_STATUS).find((item) => item.value === text)?.label ?? ''}
                </>
        },
    ]
    const onDrawerNavigation = () => {
        setVisible(true)
    }
    return (
        <div className="home-container">
            <div className="top-wrap">
                <div className="right">
                    <div className="onebox" onClick={() => { addNav('2-1') }} style={{ cursor: 'pointer'}}>
                        <img src={资产总额} style={{ height: '50px', marginTop: '15px', marginLeft: '50px' }} />
                        <div style={{ marginTop: '15px', marginLeft: '30px' }}>
                            <div style={{ color: '#ffff', fontWeight: 500, }}> 资产总额 </div>
                            <div style={{ color: '#ffff', fontWeight: 'bold', fontSize: '20px' }}> ￥{aa}</div>
                        </div>
                    </div>
                    <div className="twobox"  onClick={() => { addNav('2-1') }} style={{ cursor: 'pointer'}}>
                        <img src={资产总数} style={{ height: '50px', marginTop: '15px', marginLeft: '50px' }} />
                        <div style={{ marginTop: '15px', marginLeft: '30px' }}>
                            <div style={{ color: '#ffff', fontWeight: 500, }}> 资产总数 </div>
                            <div style={{ color: '#ffff', fontWeight: 'bold', fontSize: '20px' }}> {bb} </div>
                        </div>
                    </div>
                    <div className="threebox"  onClick={() => { addNav('2-6') }} style={{ cursor: 'pointer'}}>
                        <img src={报废资产数} style={{ height: '50px', marginTop: '15px', marginLeft: '50px' }} />
                        <div style={{ marginTop: '15px', marginLeft: '30px' }}>
                            <div style={{ color: '#ffff', fontWeight: 500, }}> 报废资产数 </div>
                            <div style={{ color: '#ffff', fontWeight: 'bold', fontSize: '20px' }}> {cc} </div>
                        </div>
                    </div>
                    <div className="fourbox"  onClick={() => { addNav('2-6') }} style={{ cursor: 'pointer'}}>
                        <img src={闲置资产数} style={{ height: '50px', marginTop: '15px', marginLeft: '50px' }} />
                        <div style={{ marginTop: '15px', marginLeft: '30px' }}>
                            <div style={{ color: '#ffff', fontWeight: 500, }}> 闲置资产数 </div>
                            <div style={{ color: '#ffff', fontWeight: 'bold', fontSize: '20px' }}> {dd} </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="second-wrap">
                <div className="middle">
                    <div className="head">
                        <div className="title">待办事项</div>
                        <div>
                            <span style={{ color: '#9698A3', fontSize: '15px', cursor: 'pointer' }} onClick={() => { addNav('5-1') }}>查看更多</span>
                        </div>
                    </div>
                    <Tabs style={{ margin: '0 20px' }}>
                        <Tabs.TabPane tab="我的申请" key="creat">
                            <Table
                                scroll={{ x: 'max-content', y: 70 }}
                                style={{ border: '1px solid #e6eaf2' }}
                                rowKey={(record) => record.id}
                                columns={myColumns}
                                dataSource={myCreatList}
                                bordered
                                pagination={false}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="我的待办" key="apply">
                            <Table
                                scroll={{ x: 'max-content', y: 70 }}
                                style={{ border: '1px solid #e6eaf2' }}
                                rowKey={(record) => record.id}
                                columns={columns}
                                dataSource={waitList}
                                bordered
                                pagination={false}
                            />
                            {applyVisible && <ApplyModal />}
                        </Tabs.TabPane>
                    </Tabs>
                </div>
                <div className="right">
                    <div className="head">
                        <div className="title">快捷导航</div>
                        <div>
                            <span style={{ color: '#666666', fontSize: '15px', cursor: 'pointer' }} onClick={onDrawerNavigation}><SettingOutlined /></span>
                        </div>
                    </div>
                    {checkValues.length !== 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignContent: 'flex-start', justifyContent: 'flex-start', marginLeft: '10px' }}>
                            {checkValues?.map((item) =>
                                <div style={{ width: '80px', height: '80px', cursor: 'pointer', display: 'flex', flexDirection: 'column' }}>
                                    <div>
                                        <FontIcon type={IconStatusEnum[IconNameEnum[item]]} style={{ fontSize: '36px', margin: '12px 0px 5px 24px', color: '#51DF92' }} onClick={() => { changeUrl(IconNameEnum[item]) }} />
                                    </div>
                                    <span style={{ textAlign: 'center', fontSize: '15px', lineHeight: '30px', color: '#333333' }}>{IconNameEnum[item]}</span>
                                </div>)}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignContent: 'flex-start', justifyContent: 'flex-start', marginLeft: '10px' }}>
                            {optionsList.slice(0, 6)?.map((item) =>
                                <div style={{ width: '80px', height: '80px', cursor: 'pointer', display: 'flex', flexDirection: 'column' }}>
                                    <div>
                                        <FontIcon type={IconStatusEnum[IconNameEnum[item]]} style={{ fontSize: '36px', margin: '12px 0px 5px 24px', color: '#51DF92' }} onClick={() => { changeUrl(IconNameEnum[item]) }} />
                                    </div>
                                    <span style={{ textAlign: 'center', fontSize: '15px', lineHeight: '30px', color: '#333333' }}>{IconNameEnum[item]}</span>
                                </div>)}
                        </div>
                    )}
                </div>
            </div>
            <div className="bottom-wrap">
                    <div className="left">
                        <div className="head">
                            <div className="title">全部资产</div>
                            <div>
                                <span style={{ color: '#9698A3', fontSize: '15px', cursor: 'pointer' }} onClick={() => { addNav('2-6') }}>查看更多</span>
                            </div>
                        </div>
                        <PageHeader />
                        <Table
                            rowKey={(record) => record.id}
                            columns={bottonTabnecolumns}
                            dataSource={dataSource}
                            bordered
                            pagination={{
                                ...pgCfg,
                                position: ['bottomRight'],
                                showTotal: () => `共${pgCfg.total}条`,
                                onChange: (pageNum, pageSize) => {
                                    loadDataTable({ pageNum, pageSize })
                                },
                                showSizeChanger: true
                            }}
                            style={{ margin: '0 20px', border: '1px solid #e6eaf2' }}
                            scroll={{ x: 'max-content', y: '410px' }}
                        />


                    </div>
                <div className="right">
                    <div className="first">
                        <span style={{ fontSize: '16px', fontWeight: 600 }}>资产状态占比</span>
                        <GLDWZJ data={orgInsertData} />
                    </div>
                    <div className="seacend">
                        <span style={{ fontSize: '16px', fontWeight: 600 }}>资产分类</span>
                        <ZTZB data={newOrgInsertData} />
                    </div>
                </div>
                {visible && <NavigationModel />}
            </div>
        </div>
    )
}
